import { useQuery } from "@tanstack/react-query";
import { loadTextureLibrary } from "@/shared/catalog";
import { internalKeys } from "./keys";

export const useTextureLibrary = () =>
	useQuery({
		queryKey: internalKeys.textureLibrary,
		queryFn: async () => {
			try {
				await loadTextureLibrary();
				return true;
			} catch (error: unknown) {
				console.warn("Отделка: библиотека текстур не загрузилась", error);
				throw error;
			}
		},
		networkMode: "always",
		retry: false,
		staleTime: Infinity,
	});
